import React from 'react';
import '../App.css';

function MainVisual() {
  return (
    <section className="main-visual-bg" id="main-visual">
      <div className="main-visual-overlay"></div>
      <div className="main-visual-content">
        <h1>智领未来：构建一体化、个性化<br />数字健康管理平台</h1>
        <p>融合前沿AI、云技术与深度本地化策略，<br />我们致力于打通数据孤岛，重塑医患协作模式，<br/>实现从院内治疗到院外康复的全周期、智能化健康管理。</p>
      </div>
    </section>
  );
}
export default MainVisual; 